import React from 'react';
import { Field } from 'react-final-form';
import { LabelWrapper, Asterisk } from './styles';

const FieldRequired = (props: any) => {
  const { label, validate, ...rest } = props;

  const customLabel = (
    <LabelWrapper>
      <span>{label}</span>
      <Asterisk>*</Asterisk>
    </LabelWrapper>
  );

  return <Field {...rest} label={customLabel} validate={validate} />;
};

export default FieldRequired;
